
import ArrayMixins from '@/mixins/ArrayMixins'
import SiteMixins from '@/mixins/SiteMixins'


export default {
  mixins: [ArrayMixins, SiteMixins],

  computed: {
    isBackhaul: function () {
      return this.actionData.actionType === 'RTB'
    },

    isPending: function () {
      return this.step.approvedStatus === 'Pending'
    },

    isRejected: function () {
      return this.step.approvedStatus === 'Rejected'
    },

    approvalButton: function () {
      let type = 'info'

      if (this.step.approvedStatus === 'Approved') {
        type = 'success'
      }

      if (this.step.approvedStatus === 'Conditional') {
        type = 'warning'
      }

      if (this.step.approvedStatus === 'Rejected') {
        type = 'danger'
      }

      return type
    }
  },

  methods: {

    isActive (data) {

      if (data) {
        return !(data.status === 'Closed' || data.status === 'Rejected')

      } else {
        return false
      }

    },



    requestTableRef (type) {
      return type.toLowerCase() + '-action-table'
    },



    /**
    * Get file URL given site_id, step, etc.
    */
    url (siteId, id, step = null, title = null, caption = null, uploadBy = null) {

      var u = this.getEndpoint('/file/upload/site/' + siteId + '/rts/' + id)

      if (step) {
        u += '/' + step
      }

      if (title) {
        u += '/' + title
      }

      if (title && step) {   // Provides caption for upload.
        u += '/' + title + ' for  step ' + step
      } else {
        if (step) {
          u += '/Request Step ' + step + ' doc'
        } else {
          u += '/' + (title ? title : (step ? 'Request Step ' + step + ' Doc' : null))
        }
      }

      if ((step || title) && this.getStore().loggedName) {
        u += '/' + this.getStore().loggedName
      }

      return u
    },



    updateEmailList (list, contacts, addMissing = false) {

      if (list && contacts) {

        var empty = (list.length === 0)

        for (var c in contacts) {
          var add = empty
          var cont = {}

          cont.name = contacts[c].name
          cont.email = contacts[c].email
          cont.sendUploadAlerts = contacts[c].sendUploadAlerts
          cont.sendApprovalAlerts = contacts[c].sendApprovalAlerts

          if (cont.email &&
            (cont.sendUploadAlerts || cont.sendApprovalAlerts)) {

            if (!empty && addMissing) {
              add = !this.exists('email', cont.email, list)
            }

            if (add) {
              list.push(cont)
            }
          } // if

        } // outer for
      }

    },


    approvalAlert (data, status, date, remarks = null, telcoId = null, info1 = null, info2 = null, info3 = null) {
      var sendMail = true

      if (data) {

        data.info.approval = status
        data.info.telcoSiteId = telcoId
        data.info.date = date
        data.info.info1 = info1
        data.info.info2 = info2
        data.info.info3 = info3
        data.info.remarks = remarks
        data.info.link = null

        sendMail = data.info.sendMail

        if (sendMail) {
          this.send(this, this.getEndpoint('mail/approval-alert'), data, status + ' Notice e-Mail', this.approvalSent)
        } else {
          this.$message({message: 'E-mails are turned off. No e-mail sent.', type: 'info'})
        }

      }
    },



    afterUpload (response, extraData = null) {
      var data = extraData
      var sendMail = true

      if (extraData) {
        data.info = extraData.info
        data.info.file = response.name

        sendMail = data.info.sendMail
        data.info.link = this.getEndpoint('file/download/' + response.url)
      }

      if (sendMail) {
        this.send(this, this.getEndpoint('mail/upload-alert'), data, 'Upload Notice e-Mail', this.uploadSent)
      } else {
        this.$message({message: 'E-mails are turned off. No e-mail sent.', type: 'info'})
      }

    },


    uploadSent (response) {
      this.$message({message: 'Upload e-mail sent', type: 'primary'})
    },

    approvalSent (response) {

      let notice = (this.step.approvedStatus === 'Approved'
      ? 'success'
      : this.step.approvedStatus === 'Conditional' ? 'warning' : 'info')

      this.$message({message: this.step.approvedStatus + ' e-mail sent', type: notice})
    },

    updateAction (value) {
      this.actionData = value
    },



    info (rowData, stepData, stepNo) {

      if (!rowData || !stepData || !stepNo) {
        return null
      }

      stepNo = Number(stepNo)

      var data = {
        info: {},
        sendTo: []
      }

      if (rowData && rowData.state && rowData.emails) {

        var prop = this.isTelco() ? 'tower' : 'telco'

        if (rowData.emails[prop]) {
          for (var i = 0; i < rowData.emails[prop].length; i++) {
            if (rowData.emails[prop][i] && !data.sendTo.includes(rowData.emails[prop][i])) {
              data.sendTo.push(rowData.emails[prop][i])
            }
          }

        }

        data.info.step = stepNo
        data.info.stepName = stepData.stepName
        data.info.sendMail = rowData.emails.sendMail ? rowData.emails.sendMail : false
        data.info.rts_id = rowData.id ? Number(rowData.id) : null
        data.info.actionType = rowData.actionType
        data.info.requestType = (rowData.actionType === 'RTS' ? 'Share' : (rowData.actionType === 'RTU' ? 'Upgrade' : rowData.actionType === 'RTB' ? 'Backhaul' : 'Other'))
        data.info.site_id = rowData.site_id ? Number(rowData.site_id) : null
        data.info.towerCoName = this.xolasClient().name ? this.xolasClient().name : 'Xolas TMS'
        data.info.email = this.xolasClient().email ? this.xolasClient().email : 'support@xolas.io'
        data.info.phone = this.xolasClient().phone ? this.xolasClient().phone : null
        data.info.siteName = rowData.site && rowData.site.siteName ? rowData.site.siteName : 'No Site Selected'
        data.info.siteId = rowData.site && rowData.site.siteId ? rowData.site.siteId : 'N/A'
        data.info.telcoSiteId = rowData.site && rowData.site.telcoSiteId
        ? rowData.site.telcoSiteId
        : (rowData.state && rowData.state.step2 && rowData.state.step2.siteId ? rowData.state.step2.siteId : 'N/A')
        data.info.sharerName = rowData.organisation && rowData.organisation.name ? rowData.organisation.name : 'No Sharer Selected'
      }

//      console.log('info: data', data, 'rowData', rowData)


      return data
    },


    /**
     * Workflow Steps: find, getSibling & workflow
     */
    findWorkflowStep (stepNo, partyNo, wf, replace = false, step = null) {

      stepNo = Number(stepNo)
      partyNo = Number(partyNo)

      if (wf) {
        for (let i = 0; i < wf.length; i++) {
          if (Number(wf[i].partyNo) === partyNo && Number(wf[i].stepNo) === stepNo) {

            if (replace && step) {
              wf[i] = step
//              console.log('replace step', replace, stepNo, partyNo, step, wf[i])
            }

            return wf[i]
          }
        }
      } else {
        this.$message({type: 'error', message: 'Workflow not found!'})
      }

      return null
    },


    workflow (partyNo, workflow) {

      partyNo = Number(partyNo)

      let wf = []

      if (partyNo > 0 && workflow && workflow.length > 0) {
        for (let i = 0; i < workflow.length; i++) {

          if (Number(workflow[i].partyNo) === partyNo) {
            wf.push({title: workflow[i].stepName, icon: workflow[i].stepIcon, colour: workflow[i].stepColour, comp: null, data: null})
          }

        }
      }

      return wf
    },



    getSibling (stepNo, stepId) {

      stepNo = Number(stepNo)
      stepId = Number(stepId)

      let list = this.rowData.steps

      if (list && stepNo && stepId) {
        for (let i = 0; i < list.length; i++) {
          if (Number(list[i].stepNo) === stepNo && Number(list[i].id) !== stepId) {
            return list[i]
          }
        }
      }
    },


    /**
     * saveRequest and saveStep
     */
    saveRequest (data, callback = null, stepData = null, failCallback = null, notifyFailureCallback = false) {

      if ((!data || !(typeof data === 'object'))) {
        return false
      }

      if (data.targetDate) {
        data.targetDate = this.formatDateSql(data.targetDate)
      }

      if (data.actualDate) {
        data.actualDate = this.formatDateSql(data.actualDate)
      }

      if (data.approved_at) {
        data.approved_at = this.formatDateSql(data.approved_at)
      }

      if (data.completed_at) {
        data.completed_at = this.formatDateSql(data.completed_at)
      }

      this.saveForm(this, '/actions', data.id, data,
        'Save ' + data.actionType + (data.status ? ' ' + data.status : ''),
        callback, failCallback || this.failedRequest, false, null, notifyFailureCallback)


      if (stepData) {
        this.saveStep(stepData)
      }

      return true
    },



    stepSaved (data) {
      if (this.actionData && data) {
        this.replaceStepData(data, this.actionData)
      }
    },



    // XOL-348: return the organisation_id of the party-1 step (the owning
    // TowerCo step). Returns null when steps are unavailable — null → no write,
    // which is the safe direction.
    requestOwnerOrgId () {
      var data = (this.actionData || this.rowData)
      var steps = data && data.steps
      if (!steps) return null
      for (var i = 0; i < steps.length; i++) {
        var s = steps[i]
        if (Number(s.partyNo) === 1) {
          return s.organisation_id != null ? s.organisation_id : null
        }
      }
      return null
    },

    // XOL-348: true only when the logged-in client owns the request.
    // Null-guards xolasClient() so an unhydrated client never throws
    // (Number(undefined) → NaN → false).
    ownsRequest () {
      var ownerId = this.requestOwnerOrgId()
      if (ownerId === null) return false
      var client = this.xolasClient()
      return Number(ownerId) === Number(client && client.id)
    },

    canWriteStep () {
      // XOL-263: only Tower Company users may fetch/save workflow steps.
      // Telcos are tenant/role-403'd by the XOL-85 backend (step writes require
      // role:manager:project|maintenance,approver:project; backhaul provider GET
      // is tenant:providerId-gated). Telco step UI is already view-only
      // (v-if="isTowerCo()"), so suppressing these calls removes the 403 toasts
      // without hiding any data they can see.
      //
      // XOL-348: also require write-capable role AND ownership.
      // Normal TowerCo users (super=0) can now SEE co-locator requests via the
      // XOL-345 read-bypass; without the ownership check the auto-saves fire and
      // produce 403 toasts. isManager()/isApprover() already short-circuit true
      // for super.
      //
      // XOL-362: Tower Co managers are authorised for all steps of all requests
      // on the Tower Co side (ticket scope), so short-circuit true for them
      // before the ownership check. This removes the dependency on xolasClient()
      // hydration timing — ownsRequest() reads xolasClient().id, an async
      // GET /system/client value that isn't hydrated yet on cold deep-link loads,
      // which was dropping legitimate managers to view-only. profile() (which
      // drives isManager()) is restored synchronously from the persisted store,
      // so it's reliable at first paint. Regular (non-manager) Tower Co users
      // still fall through to ownsRequest() to preserve XOL-348's co-locator
      // 403-suppression; super is subsumed by isManager().
      if (!this.isTowerCo()) return false
      if (this.isViewOnly()) return false
      if (!(this.isManager() || this.isApprover())) return false
      if (this.isManager()) return true
      return this.ownsRequest()
    },

    findStep (id, callback) {
      this.fetchData('step/' + id, callback, 'Request Step')
    },



    saveStep (data, callback = null, action = null, saveAction = false) {

      if (!data || !(typeof data === 'object') || data.length === 0) {
//        console.error('ERROR: saveStep incorrect data type: ', data, typeof data)
        return false
      }

      if (data.approved_at) {
        data.approved_at = this.formatDateTimeSql(data.approved_at)
      }

      if (data.completed_at) {
        data.completed_at = this.formatDateTimeSql(data.completed_at)
      }

      if (action && action.steps) {
        this.replaceStepData(data, action.steps)
      }

      this.saveForm(this, '/step', data.id, data,
        data.stepName,
        this.stepSaved, this.failedStep, false)


      if (saveAction && action) {
        this.saveRequest(action)
      }

      return true
    },


    replaceStepData (step, action) {

      if (!step || !action) {
        return
      }

      if (step.stepNo && step.partyNo && action.steps) {
        this.findWorkflowStep(step.stepNo, step.partyNo, action.steps, true, step)
      }
    },



    failedRequest (response) {
      this.actionData.site_id = null
      this.actionData.organisation_id = null

      this.$message({
        title: 'Unable to save Request',
        message: '[' + response + '] create failed',
        type: 'warning'
      })
    },



    failedStep (response) {
      this.$message({
        title: 'Unable to save Request Step',
        message: '[' + response + '] create failed',
        type: 'warning'
      })
    },


    fixExistingEquipment () {
      if (this.actionData.state.step2.equipment) {

        for (var n = 0; n < this.actionData.state.step2.equipment.length; n++) {
          let item = this.actionData.state.step2.equipment[n]

          if (this.isArray(item.type)) {
            item.category = null
            item.subType = null
            item.variant = null

            for (var i = 0; i < item.type.length; i++) {

              if (item.type[i] && i === 0) {
                item.category = item.type[i]
              }

              if (item.type[i] && i === 2) {
                item.subType = item.type[i]
              }

              if (item.type[i] && i === 3) {
                item.variant = item.type[i]
              }
            } // for

            this.actionData.state.step2.equipment[n].category = item.category
            this.actionData.state.step2.equipment[n].type = item.type[1] // else the for loop gets messed up.
            this.actionData.state.step2.equipment[n].subType = item.subType
            this.actionData.state.step2.equipment[n].variant = item.variant
          }

          if (!item.name) {
            this.actionData.state.step2.equipment[n].name = (item.category ? item.category : '')
            this.actionData.state.step2.equipment[n].name += (item.category ? ' / ' + item.type : item.type)
            this.actionData.state.step2.equipment[n].name += (item.subType ? ' / ' + item.subType : '')
            this.actionData.state.step2.equipment[n].name += (item.variant ? ' / ' + item.variant : '')
          }

        }
      }
    }


  },

  watch: {
    stepData: function (step) {
      this.step = step
//      console.log('stepData changed', this.step)
    },

    step: function (step) {
//      console.log('step changed', this.step)
      this.$emit('updated', step)
    }

  }


}
